import _asyncToGenerator from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/app/node_modules/.pnpm/@babel+runtime@7.14.6/node_modules/@babel/runtime/regenerator/index.js";
import _ from 'lodash';
import errors from 'shared/core/fieldValidationErrorMessages';
import { yup } from 'shared/core/yup';
import { ORDER_TYPE_PICKUP, ORDER_TYPE_DELIVERY } from 'shared/constants';
function userTest(_x) {
  return _userTest.apply(this, arguments);
}
function _userTest() {
  _userTest = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(value) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (value) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", this.createError({
            message: "We couldn't find a valid user for this userId"
          }));
        case 2:
          return _context.abrupt("return", true);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee, this);
  }));
  return _userTest.apply(this, arguments);
}
function photoId(_ref) {
  var requirePhotoIdForPickup = _ref.requirePhotoIdForPickup,
    requirePhotoIdForDelivery = _ref.requirePhotoIdForDelivery,
    orderType = _ref.orderType,
    isKioskOrder = _ref.isKioskOrder,
    userId = _ref.userId;
  var required = requirePhotoIdForPickup && orderType === ORDER_TYPE_PICKUP || requirePhotoIdForDelivery && orderType === ORDER_TYPE_DELIVERY;
  return {
    message: errors.photoId.missing,
    test: function test(value) {
      // Skip validation for kiosk orders with logged-in users
      if (isKioskOrder && userId) {
        return true;
      }
      if (required && _.isEmpty(value)) {
        return false;
      }
      return true;
    }
  };
}
export function getUserSchema(_ref2) {
  var orderType = _ref2.orderType,
    requirePhotoIdForDelivery = _ref2.requirePhotoIdForDelivery,
    requirePhotoIdForPickup = _ref2.requirePhotoIdForPickup,
    _ref2$makeProfileFiel = _ref2.makeProfileFieldsOptional,
    makeProfileFieldsOptional = _ref2$makeProfileFiel === void 0 ? false : _ref2$makeProfileFiel,
    _ref2$isKioskOrder = _ref2.isKioskOrder,
    isKioskOrder = _ref2$isKioskOrder === void 0 ? false : _ref2$isKioskOrder,
    _ref2$userId = _ref2.userId,
    userId = _ref2$userId === void 0 ? null : _ref2$userId;
  return yup.object().nullable().required(errors.user.missing).shape({
    _id: yup.string().required(errors.user.invalid),
    services: yup.object().shape({
      password: yup.object().shape({
        bcrypt: yup.string()
      })
    }),
    emails: yup.array().required().of(yup.object().shape({
      address: yup.string().email(errors.email.invalid).required(errors.user.invalid)
    })),
    profile: yup.object().shape({
      birthday: makeProfileFieldsOptional ? yup.string().nullable() : yup.string().required(errors.birthday.missing),
      firstName: yup.string().test('len', errors.firstName.missingShort, function (v) {
        return _.trim(v).length;
      }).required(errors.firstName.missingShort),
      lastName: yup.string().test('len', errors.lastName.missingShort, function (v) {
        return _.trim(v).length;
      }).required(errors.lastName.missingShort),
      // medicalCard: null,
      phone: makeProfileFieldsOptional ? yup.string().phone(errors.phone.missing).nullable() : yup.string().phone(errors.phone.missing).required(errors.phone.missing),
      photoId: yup.string().nullable().test(photoId({
        requirePhotoIdForPickup: requirePhotoIdForPickup,
        requirePhotoIdForDelivery: requirePhotoIdForDelivery,
        orderType: orderType,
        isKioskOrder: isKioskOrder,
        userId: userId
      })),
      textNotifications: yup["boolean"](),
      emailNotifications: yup["boolean"]()
    })
  }).test({
    test: userTest
  });
}